export function orderReference(order) {
  return order?.orderNumber ? `CMD-${String(order.orderNumber).padStart(6, '0')}` : '—';
}
